import { render, staticRenderFns } from "./UserConversation.vue?vue&type=template&id=e9c870b4&scoped=true&"
import script from "./UserConversation.vue?vue&type=script&lang=js&"
export * from "./UserConversation.vue?vue&type=script&lang=js&"
import style0 from "./UserConversation.vue?vue&type=style&index=0&id=e9c870b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c870b4",
  null
  
)

export default component.exports